$(document).ready(function() {
  if (window.innerWidth < 768) {
    let filterValues = [];
    let originalFilterValues = []; 

    function applyFilters() {
      const url = new URL(window.location);
      url.searchParams.delete('filter.v.availability');
      filterValues.forEach(filter => {
        url.searchParams.append(filter.name, filter.value);
      });
      if (!filterValues.some(filter => filter.name === 'filter.v.availability')) {
        filterValues.push({ name: 'filter.v.availability', value: '1' });
      }
      window.history.replaceState({}, '', url);

      location.reload();
    }
    
    function updateUrl() {
      const url = new URL(window.location);
      url.searchParams.delete('filter.v.availability');
      filterValues.forEach(filter => {
        url.searchParams.append(filter.name, filter.value);
      });
      if (!filterValues.some(filter => filter.name === 'filter.v.availability')) {
        filterValues.push({ name: 'filter.v.availability', value: '1' });
      }
      window.history.pushState({}, '', url);
    }
    
    function applyInStockFilter() {
      let availability = document.querySelector('.mobile-view .filter-group-display__list-item.auto-availability--apply');
      if (availability) {
        if (!filterValues.some(filter => filter.name !== 'filter.v.availability')) {
          filterValues.push({ name: 'filter.v.availability', value: '1' });
        } else {
          filterValues = filterValues.filter(filter => filter.name !== 'filter.v.availability');
        }
      }
    }
    
    $(document).on('click', '.filter-group-wrapper input', function() {
      let queryvalue = $(this).val();
      let queryname = $(this).attr('name');
      if ($(this).is(":checked")) {
        filterValues.push({ name: queryname, value: queryvalue });
      } else {
        filterValues = filterValues.filter(filter => filter.name !== queryname);
        const url = new URL(window.location);
        url.searchParams.delete(queryname, queryvalue);
        window.history.pushState({}, '', url);
      }
      applyInStockFilter();
    });
    
    $('.filterFooter .filters-btn.apply-btn').on('click', function() {
      updateUrl();
      applyFilters();
    });

    $('.filterFooter .filters-btn.cancel-btn').on('click', function () {
      if (filterValues.length > 0) {
        $('#popup').show();
      } else {
        filterValues = originalFilterValues.slice(); // Copy the original values back
        location.reload();
      }
    });
    
    $('#discard-btn').on('click', function () {
      $('#popup').hide();
      location.reload();
    });

    $('#keep-btn').on('click', function () {
      $('#popup').hide();
    });
    originalFilterValues = filterValues.slice();
  }else{
    $(document).on('change', '.filter-group-wrapper input', function() {
      const url = new URL(window.location);
      let queryvalue = $(this).val();
      let queryname = $(this).attr('name');
      let availability = document.querySelector('.filter-group-display__list-item.auto-availability--apply');
      
      if ($(this).is(":checked")) {
        let currentLoader = this.value.replace(' ', '-');
        this.parentNode.nextElementSibling.classList.add('nested');
        this.parentNode.nextElementSibling.style.display = null;
        url.searchParams.append(queryname, queryvalue);
        if(availability){
          var newurl = '';
          if(window.location.search.includes('filter.v.availability')){
            var newurl = url;
          }else{
            var newurl = url + '&filter.v.availability=1';
          }
          window.history.replaceState({}, '', newurl);
        }else{
          window.history.replaceState({}, '', url);
        }
        document.querySelectorAll('.page-loader.' + currentLoader).forEach(loader =>{
          loader.style.display = null;
        });
      }else { // Unchecked case
        let currentLoader = this.value.replace(' ', '-');
        this.parentNode.nextElementSibling.classList.remove('nested');
        this.parentNode.nextElementSibling.style.display = 'none';
        url.searchParams.delete(queryname);
        if(window.location.search.includes('filter.v.availability')){
          var searchParams = new URLSearchParams(url.search);
          searchParams.delete('filter.v.availability');
          newurl = url.origin + url.pathname + '?' + searchParams.toString();
          window.history.replaceState({}, '', newurl);
        } else {
          window.history.replaceState({}, '', url);
        }
        document.querySelectorAll('.page-loader.' + currentLoader).forEach(loader =>{
          loader.style.display = 'none';
        });
      }
      setTimeout(() => {
        location.reload();
      }, 500);
    });
  }
});




$(document).on('change', '.filter-group-wrapper .price_range input', function() {
  const url = new URL(window.location);
  let queryvalue = $(this).val();
  let queryname = $(this).attr('name');
  url.searchParams.set(queryname, queryvalue);
  window.history.pushState({}, '', url);
  setTimeout(function() {
    location.reload();
  }, 250);
});

$(document).on('click', '.filter-title', function() {
  $(this).toggleClass('dropdown').siblings('.filter-group-display').slideToggle(250);
});

// price slider change value
const rangeMinValue = (e) => {
  let val = e.value;
  let percent = parseInt(val / (e.max - e.min) * 100);
  document.querySelectorAll('.full-range').forEach(incRange => {
      incRange.style.setProperty('--min-range', `${percent}%`);
  });
  document.querySelectorAll('.progress-price.gte span').forEach(pEle => {
    pEle.innerHTML = `₹ ${val}`;
});
}

const rangeMmaxValue = (e) => {
  let val = e.value;
  let percent = 100 - parseInt(val / (e.max - e.min) * 100);
  document.querySelectorAll('.full-range').forEach(incRange => {
      incRange.style.setProperty('--max-range', `${percent}%`);
  });
  document.querySelectorAll('.progress-price.lte span').forEach(pEle => {
    pEle.innerHTML = `₹ ${val}`;
});
}

const minmaxrange = () => {
  let lteRange = document.querySelectorAll('[name="filter.v.price.lte"]');
  lteRange.forEach(rangeBar => {
      rangeMmaxValue(rangeBar);
      rangeBar.addEventListener('input', (e) => {
        rangeMmaxValue(e.currentTarget);
      })
  });
  let gteRange = document.querySelectorAll('[name="filter.v.price.gte"]');
  gteRange.forEach(rangeBar => {
      rangeMinValue(rangeBar);
      rangeBar.addEventListener('input', (e) => {
        rangeMinValue(e.currentTarget);
      })
  });
}

const changeURL = (name,val) => {
  const url = new URL(window.location);
  let queryvalue = val;
  let queryname = name;
  url.searchParams.set(queryname, queryvalue);
  window.history.pushState({}, '', url);
  setTimeout(function() {
    location.reload();
  }, 250);
}

const rangeBarFn = () => {
  let rangeSlide = document.querySelectorAll('.range-slider input[type="range"]');
  rangeSlide.forEach(input => {
    input.addEventListener('input', (e) => {
      let that = e.currentTarget;
      
      let input1 = that.closest('.range-slider').querySelector('input[name="filter.v.price.gte"]');
      let input2 = that.closest('.range-slider').querySelector('input[name="filter.v.price.lte"]');

      let input1Val = parseInt(that.closest('.range-slider').querySelector('input[name="filter.v.price.gte"]').value);
      let input2Val = parseInt(that.closest('.range-slider').querySelector('input[name="filter.v.price.lte"]').value);

      if( input1Val > input2Val ){ var tmp = input2Val; input2Val = input1Val; input1Val = tmp;}
      
      minmaxrange();
      changeURL(input1.name,input1Val);
      changeURL(input2.name,input2Val);

    })
  })
}

window.addEventListener('DOMContentLoaded', () => {  
    rangeBarFn()
})
minmaxrange();

